<template>
  <div :class="['mastery-mobile-menu-component', { active }]">
    <div class="menu-header">
      <p class="header-text">
        Account Info
      </p>
      <button
        class="close-btn"
        aria-label="Close"
        @click="closeMenu"
      >
        <icon
          name="cross-thin"
          class="close-icon"
        />
      </button>
    </div>
    <ul class="menu-links">
      <li
        v-for="link in menuLinks"
        :key="link.name"
        class="menu-link-item"
      >
        <router-link
          :to="link.route"
          class="menu-link"
          @click.native="closeMenu"
        >
          <icon
            :name="link.icon"
            class="link-icon"
          />
          {{ link.name }}
        </router-link>
      </li>
    </ul>
    <div class="footer">
      <button
        v-if="showUpgrade"
        class="join-btn"
        @click="showUpsell"
      >
        <icon
          class="lock-icon"
          name="lock"
        />
        Join Now
      </button>
      <menu-footer />
    </div>
  </div>
</template>

<script>
import Icon from '@components/singletons/icon';
import MenuFooter from '@components/ui/menu/footer';

const links = {
  authenticated: [
    {
      name: 'Profile',
      route: { name: 'mastery#profile' },
      icon: 'profile',
    },
    {
      name: 'Support',
      route: { name: 'support' },
      icon: 'phone-outline',
    },
    {
      name: 'Sign Out',
      route: { name: 'signOut' },
      icon: 'sign-out',
    },
  ],
  default: [
    {
      name: 'Support',
      route: { name: 'support' },
      icon: 'phone-outline',
    },
    {
      name: 'Sign In',
      route: { name: 'signIn' },
      icon: 'profile',
    },
  ]};

export default {
  components: { Icon, MenuFooter},
  computed: {
    active() {
      return this.$store.getters['session/showMobileMenu'];
    },
    authenticated() {
      return this.$store.getters['session/authenticated'];
    },
    menuLinks() {
      if (this.authenticated) {
        return links.authenticated;
      }
      return links.default;
    },
    nonSubscriber() {
      return !this.$store.getters['session/currentUser']?.subscriptionReceipt;
    },
    showUpgrade() {
      const pvar = this.$store.getters['productVars/get']['disable_web_top_bar_upgrade'];
      const disabledByPVar = pvar && (pvar.parsedValue === true);
      return this.nonSubscriber && !disabledByPVar;
    },
  },
  methods: {
    closeMenu() {
      this.$store.commit('session/toggleMobileMenu', false);
    },
    showUpsell() {
      this.$store.dispatch('ui/toggleUpsellModal', { show: true });
    },
  },
};
</script>

<style lang="scss" scoped>
.mastery-mobile-menu-component {
  $menu-width: rem-calc(264);

  position: fixed;
  left: 100vw;
  right: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 1000;
  display: none;
  width: $menu-width;
  background-color: #ffffff;
  flex-direction: column;
  transition: .25s ease-in left;

  @include breakpoint(small) {
    display: flex;
  }


  &.active {
    left: calc(100vw - #{$menu-width});

    &::before {
      content: "";
      position: absolute;
      top: 0;
      right: $menu-width;
      background: rgba(0, 0, 0, .39);
      width: 100vw;
      height: 100vh;
    }
  };


  .menu-header {
    border-bottom: 2px solid #00dbfb;
    padding: rem-calc(18) rem-calc(24) rem-calc(14);
    display: flex;
    justify-content: space-between;

    .header-text {
      text-transform: uppercase;
      margin: 0;
      padding: 0;
      font-weight: $semi-bold;
      letter-spacing: 1px;
    }

    .close-btn {
      border: none;
      background: transparent;
      padding: 0;

      .close-icon {
        width: rem-calc(14);
        height: rem-calc(14);
      }
    }

  }

  .menu-links {
    margin: 0;
    padding: rem-calc(32);
    list-style-type: none;

    .menu-link-item {
      margin-bottom: rem-calc(32);

      .menu-link {
        text-decoration: none;
        color: inherit;
        vertical-align: middle;
      }

      .link-icon {
        vertical-align: middle;
        margin-right: rem-calc(16);
        width: rem-calc(20);
      }
    }
  }

  .footer {
    margin: auto auto rem-calc(16);

    .join-btn {
      width: 100%;
      text-transform: uppercase;
      padding: rem-calc(16) 0;
      border-radius: rem-calc(9);
      border: solid 1px #e5e5e5;
      background: linear-gradient(to bottom, #fffefe, #f4f5f8);
      font-weight: $semi-bold;
      letter-spacing: 1px;
      margin-bottom: rem-calc(32);

      .lock-icon {
        width: rem-calc(16);
        margin-right: rem-calc(16);
      }
    }

    /deep/ .menu-footer-container {
      letter-spacing: 0.5px;
      .copyright,
      .legal-links,
      .legal-links a {
        color: #000000;
        line-height: 1.5;
      }
    }
  }
}
</style>
